import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { ui } from 'components';
import apiHOCs from 'components/apiHOCs';

import 'assets/screens.scss';
import './style.scss';

const ProductScene = ({
  productApiHOC: { product },
  addProduct,
}) => (
  product ?
    <div className="product-layout">
      <ui.Product addProduct={addProduct} {...product} />
      {/*<hr className="product-layout__hr" />*/}
      {/*<h3 className="product-layout__related-caption">Ещё термобелье серии <span>Comfort</span></h3>*/}
      {/*<div className="product-layout__related-products">*/}
        {/*{product.relatedProducts.map(item => <ui.ProductCard key={item.id} {...item} />)}*/}
      {/*</div>*/}
    </div> :
    <ui.LoadingSpinner fullSize />
);

ProductScene.propTypes = {
  addProduct: PropTypes.func.isRequired,
  productApiHOC: PropTypes.shape({
    product: PropTypes.object,
  }).isRequired,
};

export default compose(
  apiHOCs.ProductApiHOC({ getProductId: props => props.match.params.productId }),
)(ProductScene);



// WEBPACK FOOTER //
// ./src/scenes/ProductScene/index.js